import { DocumentOrigin, type DocumentDTO } from "@pentacode/core";
import type { IconName } from "@pentacode/ui/components";

export const documentOriginMeta: Record<DocumentOrigin, { label: string; icon: IconName }> = {
    [DocumentOrigin.Manager]: {
        label: "Manager",
        icon: "icon.role.manager",
    },
    [DocumentOrigin.EmployeeApp]: {
        label: "Mitarbeiter",
        icon: "icon.object.mobile-app",
    },
    [DocumentOrigin.API]: {
        label: "Drittanbieter",
        icon: "icon.object.integration",
    },
    [DocumentOrigin.Recruiting]: {
        label: "Bewerber",
        icon: "icon.feature.recruiting",
    },
};

export const documentOriginOptions = Object.values(DocumentOrigin);

export function documentMatchesOrigins(
    document: Pick<DocumentDTO, "origin">,
    activeOrigins: ReadonlySet<DocumentOrigin>
): boolean {
    return activeOrigins.has(document.origin);
}
